import axios from '@/axios'

export default {
  fetchAll(params, id){
    return axios.get(`/factory-contacts/all/${id}`, {params})
  },
  fetchLimit(params, id){
    return axios.get(`/factory-contacts/limit/${id}`, {params})
  },  
  fetchById(id){
    return axios.get(`/factory-contacts/${id}`)
  },    
  create(payload){
    return axios.post(`/factory-contacts`, payload)
  },
  update(id, payload){
    return axios.put(`/factory-contacts/${id}`, payload)
  },
  delete(id){
    return axios.delete(`/factory-contacts/${id}`)
  }, 
  deleteMultiple(payload){
    return axios.delete(`/factory-contacts`, payload)
  }
}